export enum ScoreTypes {
  Rating = 'score_rating',
  Comment = 'score_comment',
}
